import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@origin-digital/style-guide';
import { ExpandMoreIcon, PlaceIcon } from '@origin-digital/icon';
import { Select } from '../SelectElement';
var FullSelectContainer = styled.div.withConfig({
  displayName: "PropertySelect__FullSelectContainer",
  componentId: "igbsqt-0"
})(["display:flex;flex:1 1;align-items:center;flex-direction:row;>:first-child{margin-right:8px;}"]);
var StyledExpandMoreIcon = styled(ExpandMoreIcon).withConfig({
  displayName: "PropertySelect__StyledExpandMoreIcon",
  componentId: "igbsqt-1"
})(["pointer-events:none;background:", ";"], Colors.WHITE);
var SelectIconsContainer = styled.div.withConfig({
  displayName: "PropertySelect__SelectIconsContainer",
  componentId: "igbsqt-2"
})(["pointer-events:none;background:", ";"], Colors.WHITE);
export var FullSelect = function FullSelect(props) {
  return React.createElement(FullSelectContainer, null, React.createElement(PlaceIcon, {
    color: "grey48",
    size: 20
  }), React.createElement(Select, props), React.createElement(StyledExpandMoreIcon, {
    color: "red"
  }));
};
export var CompactSelect = function CompactSelect(props) {
  return React.createElement(React.Fragment, null, React.createElement(Select, _extends({}, props, {
    hidden: true
  })), React.createElement(SelectIconsContainer, null, React.createElement(PlaceIcon, {
    color: "grey48",
    size: 20
  }), React.createElement(ExpandMoreIcon, {
    color: "red"
  })));
};